// filepath: /c:/Users/joanr/Desktop/pagina web de blog para adsense/mi-app/src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Tu configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB0dXY3iJuJObir4Doc-YivIBfkr9jt9hY",
  authDomain: "blog-wenow-social.firebaseapp.com",
  projectId: "blog-wenow-social",
  storageBucket: "blog-wenow-social.appspot.com",
  messagingSenderId: "811797199481",
  appId: "1:811797199481:web:9a4ad14541878c1fa072a8",
  measurementId: "G-MBPE3L6QXH"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Exporta los módulos necesarios
export { app, analytics, auth, db, storage };